import React, { useState } from "react";
import "./AboutMe.css";
import avatarLevel1 from "./assets/about.jpg"; // Level 1 Avatar
import avatarLevel2 from "./assets/about_level2.JPG"; // Level 2 Avatar
import avatarLevel3 from "./assets/about_level3.jpg"; // Level 3 Avatar


function AboutMe() {
  const [xp, setXp] = useState(750); // Start XP
  const [level, setLevel] = useState(1);
  const [showLevel2, setShowLevel2] = useState(false);
  const [showLevel3, setShowLevel3] = useState(false);
  const [bidAmount, setBidAmount] = useState(""); // Store auction bid
  const [bidCorrect, setBidCorrect] = useState(null); // Track bid correctness

  // Function to gain XP and level up
  const gainXp = () => {
    let newXp = xp + 100;

    if (newXp >= 1000 && level === 1) {
      setLevel(2);
      setShowLevel2(true);
    } else if (newXp >= 2000 && level === 2) {
      setLevel(3);
      setShowLevel3(true);
    }

    setXp(newXp > 2000 ? 2000 : newXp); // Prevent overflow
  };

  // Function to check auction bid
  const checkBid = () => {
    const bid = parseInt(bidAmount, 10);
    if (bid >= 50 && bid <= 75) {
      setBidCorrect(true);
      setXp(xp + 500); // Bonus XP for correct bid
    } else {
      setBidCorrect(false);
    }
  };

  return (
    <div className={`about-container ${showLevel2 ? "level-2" : ""} ${showLevel3 ? "level-3" : ""}`}>
      {/* Left Side - Text Content */}
      <div className="about-text">
        <h2>{level === 1 ? "About Me" : level === 2 ? "Level 2 Unlocked! 🎉" : "Level 3: The Final Stage! 🚀"}</h2>
        <p>
          I'm Abinash, a passionate developer exploring AI, compilers, and distributed systems.
          Every project I undertake is a step forward in my journey of mastering technology.
          Currently, I am pursuing Masters in Computer Science at the University of Texas at Dallas.
          I aspire to work on ML compilers here as a thesis project.
        </p>
        <h4>Feel free to hit the XP button to move to next level</h4>
        {/* Level 2 - More details */}
        {showLevel2 && (
          <>
            <h3>🔓 New Info Unlocked!</h3>
            <p>
            Before coming here I got an opportunity to work at Cisco Systems in India as a Software/Network Engineer.
              I worked there on full stack web development and also contributed to open source projects like DNA Center Ansible.
              I firmly believe current world is driven by latency and networks do play a major role in the world of low latency.
              This inspired me to work on my latest project related to low latency trading system. 
            </p>
          </>
        )}
       
        {/* Level 3 - Auction Puzzle Unlocks */}
        {showLevel3 && (
          <>
            <h3>🚀 Final Achievement Unlocked!</h3>
            <p>
            If you've reached here, you're a true explorer. 
              Just like in coding, life is about constant leveling up. 
              I love to watch movies and paint cartoons in my leisure time.
              Sometimes I do love to solve puzzles to stay sharp. Here is a quick puzzle for you to gain extra credits.
              Thanks for visiting my portfolio!
            </p>

            <p><strong>🛒 Auction Challenge:</strong></p>
            <p>
              You and one other player are bidding for a rare item worth **$100** in a **sealed-bid, first-price auction**.
              To **maximize profit**, you must find the **optimal bid** (a balance between winning and not overpaying).
            </p>
            <p><strong>Enter a bid between $1 and $100:</strong></p>

            {/* Auction Puzzle Input */}
            <input
              type="number"
              value={bidAmount}
              onChange={(e) => setBidAmount(e.target.value)}
              placeholder="Enter your bid ($)"
              className="puzzle-input"
            />
            <button className="puzzle-btn" onClick={checkBid}>
              Submit Bid
            </button>

            {/* Auction Puzzle Result */}
            {bidCorrect === true && <p className="puzzle-success">✅ Correct! +500 XP Awarded!</p>}
            {bidCorrect === false && <p className="puzzle-fail">❌ Wrong! Try a more strategic bid.</p>}
          </>
        )}

        {/* XP Progress and Level System */}
        <div className="xp-bar-container">
          <p>🎮 XP Progress: {xp} / 2000</p>
          <div className="xp-bar">
            <div className="xp-fill" style={{ width: `${(xp / 2000) * 100}%` }}></div>
          </div>
          <p>🏆 Level: {level}</p>
        </div>

        {/* Gain XP Button */}
        {level < 3 && (
          <button className="gain-xp-btn" onClick={gainXp}>
            Gain XP
          </button>
        )}
      </div>

      {/* Right Side - Avatar Changes on Level Up */}
      <div className="about-avatar">
        <img src={level === 1 ? avatarLevel1 : level === 2 ? avatarLevel2 : avatarLevel3} alt="Abinash Avatar" />
      </div>
    </div>
  );
}

export default AboutMe;
